import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
export var state = function state() {
  return {
    newRelicScript: ''
  };
};
export default {
  namespaced: false,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};